import { FormDialog } from 'components/dialog/form'
import { SearchsSenmoniResult, usePostSearchsSenmoni } from 'interface/search/senmoni'
import { useSearchsSenmoniForm, SearchsSenmoniForm } from '../form'

type AddSearchsSenmoniDialogProps = {
  searchId: number
  onSubmit: (result: SearchsSenmoniResult) => void
  onClose: () => void
}
export const AddSearchsSenmoniDialog = ({
  searchId,
  onSubmit,
  onClose
}: AddSearchsSenmoniDialogProps) => {
  const [postState, submit] = usePostSearchsSenmoni(searchId, { onPosted: onSubmit })
  const form = useSearchsSenmoniForm({ searchId, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="分析対象の専門医を登録"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsSenmoniForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
